/**
 * Central config: factor weights (47 keys sum to 1), level breakpoints.
 * Threshold bands live in ./scoringBands.js; scoring helpers in ../utils/scoringUtils.js
 */

const FACTOR_KEYS = [
  'total_company_tenure',
  'time_in_current_role',
  'time_since_last_promotion',
  'time_since_last_comp_change',
  'career_velocity_vs_peers',
  'tenure_band',
  'salary_vs_market_midpoint',
  'salary_vs_internal_peers',
  'compensation_growth_rate',
  'bonus_incentive_consistency',
  'equity_lti_value',
  'total_rewards_competitiveness',
  'external_demand_for_role',
  'skill_transferability',
  'internal_mobility_availability',
  'role_criticality',
  'role_scope_stability',
  'promotion_path_clarity',
  'performance_rating_trend',
  'performance_reward_mismatch',
  'recognition_frequency',
  'workload_pressure',
  'performance_volatility',
  'manager_tenure',
  'manager_change_frequency',
  'manager_span_of_control',
  'manager_team_attrition_history',
  'manager_performance_stability',
  'manager_engagement_signal',
  'team_attrition_rate',
  'team_attrition_trend',
  'average_team_tenure',
  'team_tenure_dispersion',
  'team_internal_mobility_rate',
  'team_workload_pressure',
  'high_risk_cluster_density',
  'org_change_exposure',
  'reorg_frequency',
  'leadership_change_exposure',
  'budget_pressure_signal',
  'location_site_instability',
  'absenteeism_change',
  'productivity_change',
  'collaboration_drop',
  'manager_checkin_drop',
  'local_market_hiring_pressure',
  'competitor_talent_pull',
];

const n = FACTOR_KEYS.length;
const equalW = 1 / n;
const factorWeights = Object.fromEntries(FACTOR_KEYS.map((k) => [k, equalW]));

const sumFactorWeights = FACTOR_KEYS.reduce((s, k) => s + factorWeights[k], 0);

module.exports = {
  FACTOR_KEYS,
  factorWeights,
  sumFactorWeights,

  /** Inclusive bands: 0–lowMax low, (lowMax+1)–moderateMax moderate, etc. → 0-24 low, 25-49 moderate, 50-74 high, 75+ critical */
  levelBreakpoints: {
    lowMax: 24,
    moderateMax: 49,
    highMax: 74,
  },
};
